/* NGR — comportamiento mínimo: aparición al hacer scroll y selector de color. */
(function () {
  'use strict';

  /* --- aparición al entrar en pantalla ---------------------------------- */
  function watchRise(root) {
    var items = (root || document).querySelectorAll('.mt-rise:not(.mt-watched)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-in', 'mt-watched'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    items.forEach(function (el) {
      el.classList.add('mt-watched');
      io.observe(el);
    });
  }

  /* --- selector de color ------------------------------------------------ */
  /* Cada ficha lleva data-mt-pick; al activarla muestra su panel hermano. */
  function bindPicker(root) {
    var pickers = (root || document).querySelectorAll('[data-mt-picker]:not(.mt-bound)');
    pickers.forEach(function (picker) {
      picker.classList.add('mt-bound');
      var chips = picker.querySelectorAll('[data-mt-pick]');
      var panels = picker.querySelectorAll('[data-mt-panel]');

      function show(key) {
        chips.forEach(function (c) {
          var on = c.getAttribute('data-mt-pick') === key;
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-mt-panel') !== key;
        });
      }

      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () {
          show(chip.getAttribute('data-mt-pick'));
        });
        chip.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            show(chip.getAttribute('data-mt-pick'));
          }
        });
        chip.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = chips[(i + dir + chips.length) % chips.length];
          next.focus();
          show(next.getAttribute('data-mt-pick'));
        });
      });

      if (chips.length) show(chips[0].getAttribute('data-mt-pick'));
    });
  }

  /* --- acordeón de preguntas ------------------------------------------- */
  function bindFaq(root) {
    var groups = (root || document).querySelectorAll('[data-mt-faq]:not(.mt-bound)');
    groups.forEach(function (group) {
      group.classList.add('mt-bound');
      group.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          group.querySelectorAll('details[open]').forEach(function (o) {
            if (o !== d) o.open = false;
          });
        });
      });
    });
  }

  /* --- comparador antes / después --------------------------------------- */
  function bindBeforeAfter(root) {
    var stages = (root || document).querySelectorAll('[data-mt-ba]:not(.mt-bound)');
    stages.forEach(function (stage) {
      stage.classList.add('mt-bound');
      var range = stage.querySelector('.mt-ba__range');
      if (!range) return;

      function set(pct) {
        var v = Math.max(0, Math.min(100, pct));
        stage.style.setProperty('--mt-pos', v + '%');
        if (range.value !== String(v)) range.value = v;
      }

      range.addEventListener('input', function () { set(parseFloat(range.value)); });

      /* En escritorio el cursor manda; en táctil se usa el control deslizante. */
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      stage.addEventListener('pointermove', function (e) {
        if (!fine.matches || e.pointerType !== 'mouse') return;
        var r = stage.getBoundingClientRect();
        if (!r.width) return;
        set(((e.clientX - r.left) / r.width) * 100);
      });

      stage.addEventListener('pointerleave', function (e) {
        if (!fine.matches || e.pointerType !== 'mouse') return;
        set(50);
      });

      set(parseFloat(range.value) || 50);
    });
  }

  /* --- inclinación de la credencial según la posición del cursor -------- */
  function bindTilt(root) {
    var cards = (root || document).querySelectorAll('[data-mt-tilt]:not(.mt-bound)');
    cards.forEach(function (card) {
      card.classList.add('mt-bound');
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

      card.addEventListener('pointermove', function (e) {
        if (!fine.matches) return;
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--mt-tilt-x', (-y * 12).toFixed(2) + 'deg');
        card.style.setProperty('--mt-tilt-y', (x * 14).toFixed(2) + 'deg');
      });

      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--mt-tilt-x', '0deg');
        card.style.setProperty('--mt-tilt-y', '-5deg');
      });
    });
  }

  function boot(root) {
    watchRise(root);
    bindPicker(root);
    bindFaq(root);
    bindBeforeAfter(root);
    bindTilt(root);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  if (document.readyState !== 'loading') boot(document);

  /* El editor de Shopify recarga secciones sueltas: hay que re-enlazarlas. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
